module.exports = __webpack_public_path__ + "static/img/woman_glove_1.fb95343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/woman_glove_1.png
// module id = I91x
// module chunks = 0